import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import requests from '../requests';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';
import i18n from '../../../i18n';
import {
  removeAccessToken,
  getAccessToken,
  removeIdToken,
} from '../../../utils/access-token-storage';

export function* initializeCore() {
  console.log('========== INITIALIZE CORE START ==========');

  const currentConfig = yield select(selectors.selectConfig);

  // console.log('CURRENT CONFIG');
  // console.log(currentConfig);

  let config;

  if (!currentConfig) {
    console.log('FETCH CONFIG');

    ({ item: config } = yield call(api.getConfig));

    // console.log('CONFIG RECEIVED');
    // console.log(config);

    yield put(actions.initializeCore.fetchConfig(config));
  }

  const accessToken = yield call(getAccessToken);

  // console.log('ACCESS TOKEN');
  // console.log(!!accessToken);

  if (!accessToken) {
    console.log('NO ACCESS TOKEN');

    yield call(i18n.loadCoreLocale);

    yield put({ type: 'SET_INITIALIZING_FALSE' });

    return;
  }

  console.log('CALLING FETCH CORE');

  const result = yield call(requests.fetchCore);

  // console.log('FETCH CORE RAW RESULT');
  // console.log(result);

  const {
    user,
    board,
    users,
    projects,
    projectManagers,
    boards,
    folders,
    userBoardPreferences,
    boardMemberships,
    labels,
    lists,
    cards,
    cardMemberships,
    cardLabels,
    attachments,
    activities,
    notifications,
    cardRelations,
    permissions,
    roles,
    rolePermissions,
    userRoleAssignments,
  } = result;

  // console.log('FETCH CORE DESTRUCTURED');

  // console.log('user', user);
  // console.log('board', board);

  // console.log('users count', users?.length);
  // console.log('projects count', projects?.length);
  // console.log('boards count', boards?.length);

  // console.log('projectManagers count', projectManagers?.length);
  // console.log('boardMemberships count', boardMemberships?.length);

  // console.log('roles count', roles?.length);
  // console.log('rolePermissions count', rolePermissions?.length);
  // console.log('userRoleAssignments count', userRoleAssignments?.length);

  // console.log('labels count', labels?.length);
  // console.log('lists count', lists?.length);
  // console.log('cards count', cards?.length);

  const resolvedConfig = yield select(selectors.selectConfig);

  // console.log('RESOLVED CONFIG');
  // console.log(resolvedConfig);

  const language = user.language || (resolvedConfig && resolvedConfig.defaultLanguage) || null;

  console.log('LANGUAGE');
  console.log(language);

  yield call(i18n.changeLanguage, language);
  yield call(i18n.loadCoreLocale);

  console.log('DISPATCHING CORE_INITIALIZE');

  yield put(
    actions.initializeCore(
      user,
      board,
      users,
      projects,
      projectManagers,
      boards,
      folders,
      userBoardPreferences,
      boardMemberships,
      labels,
      lists,
      cards,
      cardMemberships,
      cardLabels,
      attachments,
      activities,
      notifications,
      cardRelations,
      permissions,
      roles,
      rolePermissions,
      userRoleAssignments,
    ),
  );

  console.log('========== INITIALIZE CORE END ==========');
}

export function* changeCoreLanguage(language) {
  if (language === null) {
    yield call(i18n.detectLanguage);
    yield call(i18n.loadCoreLocale);
    yield call(i18n.changeLanguage, i18n.resolvedLanguage);
  } else {
    yield call(i18n.loadCoreLocale, language);
    yield call(i18n.changeLanguage, language);
  }
}

export function* logout(invalidateAccessToken = true) {
  yield call(removeAccessToken);
  yield call(removeIdToken);

  if (invalidateAccessToken) {
    yield put(actions.logout.invalidateAccessToken());

    try {
      yield call(request, api.deleteCurrentAccessToken);
    } catch (error) {} // eslint-disable-line no-empty
  }

  yield put(actions.logout()); // TODO: next url
}

export default {
  initializeCore,
  changeCoreLanguage,
  logout,
};
